import { Locales } from '@griply/types';
import { getPushNotificationTokenDate } from 'shared/services/local-storage';
import { ID } from 'shared/types/id';

import { createPushToken } from './create-push-token';
import { getPushToken } from './get-push-token';

export const setPushTokenOnUser = async (userId: ID, locale: Locales) => {
  // no stored date means never registered in this browser or deliberately opted out — never re-enroll
  if (!getPushNotificationTokenDate(userId)) {
    return;
  }

  if ('Notification' in window && Notification.permission !== 'granted') {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return;
    }
  }

  const token = await getPushToken(userId);

  if (token) {
    await createPushToken(userId, token, locale);
  }
};
